/** Truncated link with hover/focus underline — for primary name/title columns */
export const linkCell =
  "font-medium truncate block hover:underline focus:underline focus:outline-none";

/** Ghost icon button — for action columns with icon links/buttons */
export const iconAction =
  "inline-flex items-center justify-center size-7 rounded-md text-muted-foreground hover:bg-accent hover:text-accent-foreground cursor-pointer";

/**
 * Skeleton row height classes for the DataGrid loading state.
 *
 * Cell padding is py-1.5 (6px each side = 12px) + 1px row border.
 * The skeleton height should match the tallest cell content so that
 * loading rows are the same height as data rows.
 *
 *   text-only rows:  content ≈ 20px → row = 33px  → use "h-5"
 *   icon action rows: content = 28px → row = 41px  → use "h-7"  (size-7 iconAction)
 *   wrapped actions:  content = 32px → row = 45px  → use "h-8"  (div with multiple icons)
 */
export const skeletonRow = {
  /** 20px — matches rows containing only text */
  text: "h-5",
  /** 28px — matches rows with a single size-7 action icon (most common) */
  action: "h-7",
  /** 32px — matches rows with wrapped action buttons (flex div with multiple icons) */
  actions: "h-8",
} as const;
